export class Page {
  static fromObject(object) {
    return new Page(object.page_id, object.page_slug, object.page_title, object.page_html);
  }

  constructor(public id: number, public slug: string, public title: string, public html: string) {}
}
